module.exports = new __parcel__URL__("level_4_tab_inactive.3b4c1dc7.png").toString();